import dayjs from "~/lib/dayjs";

document.addEventListener("DOMContentLoaded", () => {
  const tz = dayjs.tz.guess();
  Cookies.set("browser.timezone", tz, {
    expires: 365,
    path: "/",
  });
});

// Set default timezone
dayjs.tz.setDefault(dayjs.tz.guess(true));
